import sites from './sites';
import perms from './perms';
import employee from './employee';

export const modules = { sites, perms, employee };
